import React, { useState } from "react";
import TemplateCard from "./templateCard";
import styles from "../../styles/_containers/_automations/categorySection.module.scss";

const CategoryIcon = ({ id }) => {
  const paths = {
    post_visit: <><path d="M5 12h14M12 5v14"/><circle cx="12" cy="12" r="9"/></>,
    subscriptions: <><rect x="5" y="4" width="14" height="16" rx="2"/><path d="M9 8h6M9 12h6M9 16h4"/></>,
    internal: <><circle cx="12" cy="12" r="3"/><path d="M12 3v3m0 12v3M3 12h3m12 0h3M5.6 5.6l2.1 2.1m8.6 8.6 2.1 2.1m0-12.8-2.1 2.1m-8.6 8.6-2.1 2.1"/></>,
    retention: <><path d="M20 7v5h-5"/><path d="M18.3 16a8 8 0 1 1 1.1-8.5L20 12"/></>,
    reviews: <path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3Z"/>,
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[id] || paths.internal}</svg>;
};

export default function CategorySection({ category, onActivate, activating }) {
  const [open, setOpen] = useState(false);
  const unactivated = category.templates.filter(template => !template.isActivated);
  if (unactivated.length === 0) return null;

  const bodyId = `automation-category-${category.id}`;

  return (
    <div className={`${styles.section} ${open ? styles.sectionOpen : ""}`}>
      <button
        className={styles.header}
        onClick={() => setOpen(current => !current)}
        type="button"
        aria-expanded={open}
        aria-controls={bodyId}
      >
        <span className={styles.icon}><CategoryIcon id={category.id} /></span>
        <span className={styles.headingText}>
          <span className={styles.title}>{category.name}</span>
          <span className={styles.hint}>{unactivated.length === 1 ? "תבנית אחת מוכנה" : `${unactivated.length} תבניות מוכנות`}</span>
        </span>
        <span className={styles.count}>{unactivated.length}</span>
        <span className={styles.arrow} aria-hidden="true">
          <svg viewBox="0 0 20 20"><path d="m6.5 8 3.5 3.5L13.5 8" /></svg>
        </span>
      </button>
      {open && (
        <div id={bodyId} className={styles.body}>
          {unactivated.map(template => (
            <TemplateCard
              key={template.id}
              template={template}
              onActivate={onActivate}
              activating={activating}
            />
          ))}
        </div>
      )}
    </div>
  );
}
